import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=29837930&"
import script from "./TheFooter.vue?vue&type=script&lang=js&"
export * from "./TheFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29837930')) {
      api.createRecord('29837930', component.options)
    } else {
      api.reload('29837930', component.options)
    }
    module.hot.accept("./TheFooter.vue?vue&type=template&id=29837930&", function () {
      api.rerender('29837930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/TheFooter.vue"
export default component.exports